var map = {
	"./biansuqi.svg": "5577",
	"./boli.svg": "56dd",
	"./dipan.svg": "5d7f",
	"./eighteen.svg": "ea04",
	"./fadongji.svg": "78ca",
	"./fangxiu.svg": "7233",
	"./luntai.svg": "4001",
	"./qichedianzi.svg": "a538",
	"./thirty_two.svg": "d7c8",
	"./yushuaqi.svg": "16cf",
	"./yvwu.svg": "b507",
	"./zhidong.svg": "e6c9",
	"./zhuanxiang.svg": "7c5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31c3";